<template>
  <div>
    <v-row>
      <v-col cols="12" md="6" class="pa-2">
        <Vw_student_overall_count/>
        <Vw_student_overall_count_province/>
      </v-col>
      <v-col cols="12" md="6" class="pa-2">
        <Vw_student_overall_count_region/>
        <Vw_student_overall_class/>
      </v-col>
      <v-col cols="12">
        <Vw_student_count_by_branch/>
      </v-col>

      <v-col cols="12">
        <Std_dashboard/>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import Std_dashboard from '../components/core/std_dashboard.vue';
import Vw_student_count_by_branch from '../components/std_dashboard/vw_student_count_by_branch.vue';
import Vw_student_overall_class from '../components/std_dashboard/vw_student_overall_class.vue';
import Vw_student_overall_count from '../components/std_dashboard/vw_student_overall_count.vue';
import Vw_student_overall_count_province from '../components/std_dashboard/vw_student_overall_count_province.vue';
import Vw_student_overall_count_region from '../components/std_dashboard/vw_student_overall_count_region.vue';

export default {
  components:{
    Vw_student_overall_count,
    Vw_student_overall_count_province,
    Vw_student_overall_count_region,
    Vw_student_overall_class,
    Vw_student_count_by_branch,
    Std_dashboard
  },
  data(){
    return{
      ApiKey:'HRvec2021'
    }
  }
}
</script>
